import { FC, useEffect, useState } from "react";

import classes from "./BattleResult.module.css";
import Button from "../UI/Button";
import { BattleModelDocument } from "../image/Image";
import { useSelector } from "react-redux";
import { userState } from "../../store/user";
import axios from "axios";
import { getLang, i18n } from "../../i18n";

interface Props {
  currentUserIndex: number;
  _id: string;
  battleID: BattleModelDocument;
  refreshUserBattles: () => Promise<void>;
  deleteNotification: (id: string) => Promise<void>;
  setPopupImage: React.Dispatch<React.SetStateAction<string>>;
}

const BattleWin: FC<Props> = ({
  currentUserIndex,
  _id,
  battleID,
  refreshUserBattles,
  deleteNotification,
  setPopupImage,
}) => {
  const lang = getLang();
  const t = i18n.battleWin[lang];

  const API_URL = process.env.REACT_APP_API_URL;
  const user = useSelector(userState);
  const [isLoading, setIsLoading] = useState(false);
  const [updatedWinnerDecision, setUpdatedWinnerDecision] = useState("");
  const takeWin = async () => {
    setIsLoading(true);
    await axios
      .patch(
        `${API_URL}/battles/takewin/${battleID._id.toString()}`,
        {},
        {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        }
      )
      .then((response) => {
        setUpdatedWinnerDecision(response.data.battle.winnerDecision);
        refreshUserBattles();
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const nextLevel = async () => {
    setIsLoading(true);
    await axios
      .patch(
        `${API_URL}/battles/nextlevel/${battleID._id.toString()}`,
        {},
        {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        }
      )
      .then((response) => {
        setUpdatedWinnerDecision(response.data.battle.winnerDecision);
        refreshUserBattles();
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  // let winAmount = 0;
  // switch (battleID.level) {
  //   case 1:
  //     winAmount = 15;
  //     break;
  //   case 2:
  //     winAmount = 20;
  //     break;
  //   case 3:
  //     winAmount = 30;
  //     break;
  //   case 4:
  //     winAmount = 45;
  //     break;
  //   case 5:
  //     winAmount = 70;
  //     break;
  //   case 6:
  //     winAmount = 110;
  //     break;
  //   case 7:
  //     winAmount = 210;
  //     break;
  // }
  useEffect(() => {
    setUpdatedWinnerDecision(battleID.winnerDecision);
  }, []);
  return (
    <div
      className={`${classes.votepair} ${classes.isResult} ${classes.resultWin}`}
    >
      {updatedWinnerDecision !== "pending" && (
        <div className={classes.delete} onClick={() => deleteNotification(_id)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 23 23"
            fill="none"
          >
            <path
              d="M16.2353 6.76471L6.76471 16.2353M6.76471 6.76471L16.2353 16.2353"
              stroke="#50A7EA"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </div>
      )}
      <div className={classes.images}>
        <div
          className={`${classes.img} ${
            battleID.user1ID === user._id ? classes.voted : ""
          }`}
          onClick={() => {
            if (currentUserIndex === 1)
              setPopupImage(battleID.artwork1ID || "");
          }}
        >
          {battleID.user1ID !== user._id && (
            <span className={classes.popupIcon} title={t.popupAlt}>
              {/* SVG icon omitted for brevity */}
            </span>
          )}
          <img src={battleID.artwork1Src} alt="" />
          <div
            className={`${classes.score} ${
              battleID.artwork1VotesCount > battleID.artwork2VotesCount
                ? classes.win
                : classes.lose
            }`}
          >
            {battleID.artwork1VotesCount}
          </div>
        </div>
        <div
          className={`${classes.img} ${
            battleID.user2ID === user._id ? classes.voted : ""
          }`}
          onClick={() => {
            if (currentUserIndex === 0)
              setPopupImage(battleID.artwork2ID || "");
          }}
        >
          {battleID.user2ID !== user._id && (
            <span className={classes.popupIcon} title={t.popupAlt}>
              {/* SVG icon omitted for brevity */}
            </span>
          )}
          <img src={battleID.artwork2Src} alt="" />
          <div
            className={`${classes.score} ${
              battleID.artwork2VotesCount > battleID.artwork1VotesCount
                ? classes.win
                : classes.lose
            }`}
          >
            {battleID.artwork2VotesCount}
          </div>
        </div>
      </div>
      <div className={`${classes.results} ${classes.resultWin}`}>
        <div>
          <div className={classes.title}>{battleID.topic.title}</div>
          <div className={classes.battleLevel}>
            {t.level} <span className={classes.levelNum}>{battleID.level}</span>
          </div>
        </div>
        <div className={classes.winLabel}>
          <span className={classes.won}>{t.youWon}</span>
          {updatedWinnerDecision === "levelUp" && (
            <div className={`${classes.result} ${classes.labelWin}`}>
              {t.levelUp
                .replace("{from}", battleID.level.toString())
                .replace("{to}", (battleID.level + 1).toString())}
            </div>
          )}
          {updatedWinnerDecision === "nft" && (
            <div className={`${classes.result} ${classes.labelWin}`}>
              {t.nft}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BattleWin;
